export const ITEM_PRICE_COPY = 'Item price';

export const OPTIONS_COPY = 'Product options';
export const PERSONALISATION_COPY = 'Personalisation';
export const ADDED_COPY = 'Added';
export const REMOVED_COPY = 'Removed';

export const TOTAL_COPY = 'Total';
